import { SidePanelDesktopLayout } from './side-panel-desktop-layout.js';
import React__default, { useContext } from 'react';
import { RicosContext } from 'ricos-context';
import { FullscreenMobileLayout } from '../fullscreen-mobile-layout/fullscreen-mobile-layout.js';
import '@wix/design-system';
import 'classnames';
import '../../ui-components-provider.js';
import './data-hooks.js';
import '../../style-inject.es-746bb8ed.js';
import '../fullscreen-mobile-layout/data-hooks.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const SidePanelLayout = (props) => {
  const { isMobile } = useContext(RicosContext);
  const Layout = isMobile ? FullscreenMobileLayout : SidePanelDesktopLayout;
  return /* @__PURE__ */ React__default.createElement(Layout, __spreadValues({}, props));
};

export { SidePanelLayout };
//# sourceMappingURL=side-panel-layout.js.map
